<script lang="ts">
    import { onMount } from "svelte";
    import { translate } from "@/utils/format";
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import { SECTIONS, isSectionId, type SectionDef } from "../lib/sections";

    const store = getDashboardCtx();

    let isMobile = $state(false);

    const locked = (s: SectionDef) => s.gated && !store.isStripeConfigured;

    onMount(() => {
        const mq = window.matchMedia("(max-width: 640px)");
        const sync = () => {
            isMobile = mq.matches;
        };
        sync();

        // Safari fallback: addListener/removeListener
        if (typeof mq.addEventListener === "function") {
            mq.addEventListener("change", sync);
            return () => mq.removeEventListener("change", sync);
        }
        mq.addListener(sync);
        return () => mq.removeListener(sync);
    });
</script>

<nav
    class="dashNav"
    aria-label={translate("PARTNER_NAV_LABEL", "Secciones del panel")}
>
    {#if isMobile}
        <select
            class="referralsTabSelect"
            value={store.section}
            onchange={(e) => {
                const v = e.currentTarget.value;
                if (isSectionId(v)) store.setSection(v);
            }}
            aria-label={translate("PARTNER_NAV_LABEL", "Secciones del panel")}
        >
            {#each SECTIONS as s (s.id)}
                <option value={s.id}>
                    {translate(s.labelKey, s.label)}{locked(s) ? " 🔒" : ""}
                </option>
            {/each}
        </select>
    {:else}
        <ul class="dashNav__list">
            {#each SECTIONS as s (s.id)}
                <li>
                    <button
                        type="button"
                        class="dashNav__item"
                        class:isActive={store.section === s.id}
                        aria-current={store.section === s.id
                            ? "page"
                            : undefined}
                        onclick={() => store.setSection(s.id)}
                    >
                        <i class={s.icon} aria-hidden="true"></i>
                        <span>{translate(s.labelKey, s.label)}</span>
                        {#if locked(s)}
                            <i
                                class="fal fa-lock dashNav__lock"
                                title={translate(
                                    "PARTNER_NAV_LOCKED",
                                    "Requiere conectar Stripe",
                                )}
                            ></i>
                        {/if}
                    </button>
                </li>
            {/each}
        </ul>
    {/if}
</nav>
